/**
 * Certified By addresses whose directory identity cannot be derived by rewriting the domain.
 *
 * The generic rule keeps the local part and forces the domain to quantaservices.com, which works for
 * most Blattner addresses. The people below have a directory address in a different form entirely
 * (firstname.lastname), so no rule produces it — the mapping has to be stated.
 *
 * Keyed by the LOCAL PART of the address as it appears in the SharePoint export, lowercased. The
 * source domain varies (blattnercompany.com / blattnerenergy.com) and is normalized away regardless,
 * so keying on the local part matches whichever domain a given row happens to use.
 *
 * To add someone: one line here, then re-upload the CSV and confirm they leave the Needs review list.
 */
export const CERTIFIER_EMAIL_BY_LOCAL_PART: Readonly<Record<string, string>> = {
    dwolfe: 'david.wolfe@quantaservices.com',     // DWolfe@blattnercompany.com
    jpruitt: 'justin.pruitt@quantaservices.com',  // JPruitt@blattnercompany.com
};
